import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosHttp from "services/axiosHttp";

export const getAssetCategories = createAsyncThunk(
    "assetCategory/getAssetCategories",
    async (_, { rejectWithValue }) => {
        try {
            const response = await axiosHttp.get("category/list?categoryType=TMS Assests&limit=100&page=1");
            return response.data;
        } catch (err) {
            if (!err.response) throw err;
            return rejectWithValue(err.response.data);
        }
    }
);

export const getAssetConditions = createAsyncThunk(
    "assetCategory/getAssetConditions",
    async (_, { rejectWithValue }) => {
        try {
            const response = await axiosHttp.get("category/list?categoryType=TMS Assests Condition&limit=100&page=1");
            return response.data;
        } catch (err) {
            if (!err.response) throw err;
            return rejectWithValue(err.response.data);
        }
    }
);

const AssetCategorySlice = createSlice({
    name: "AssetCategorySlice",
    initialState: {
        categories: [],
        conditions: [],
        isLoading: false,
        error: null,
    },
    reducers: {
        resetAssetCategory: (state) => {
            state.categories = [];
            state.conditions = [];
            state.isLoading = false;
            state.error = null;
        },
    },
    extraReducers: (builder) => {
        builder
            // Categories
            .addCase(getAssetCategories.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(getAssetCategories.fulfilled, (state, action) => {
                state.isLoading = false;
                state.categories = action.payload?.data?.docs || [];
            })
            .addCase(getAssetCategories.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
            })
            // Conditions
            .addCase(getAssetConditions.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(getAssetConditions.fulfilled, (state, action) => {
                state.isLoading = false;
                state.conditions = action.payload?.data?.docs || [];
            })
            .addCase(getAssetConditions.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
            });
    },
});

export const { resetAssetCategory } = AssetCategorySlice.actions;
export default AssetCategorySlice.reducer;
